import { toOfferNumber } from "./offerPluginStats";

/**
 * Историческая граница analyze.max_time: от 21 дня 1С считала срок неограниченным.
 * Сохраняем только для чтения старых подборов и контрактов остальных режимов.
 * Ручной подбор хранит начальный фильтр отдельно (gsDeliveryTerm.ts, CAB-851).
 */
export const GS_TERM_NO_LIMIT = 21;

/** Ограничение в днях или `null` — «без ограничения» (в т.ч. если бэк его не прислал). */
export function resolveTermLimit(maxTime: number | null | undefined): number | null {
  if (typeof maxTime !== "number" || !Number.isFinite(maxTime)) return null;
  if (maxTime <= 0 || maxTime >= GS_TERM_NO_LIMIT) return null;
  return Math.floor(maxTime);
}

/** Предложение в форме, достаточной для отбора по сроку (совместимо с GsOffer). */
export interface TermLimitCandidate {
  time_int?: unknown;
}

/**
 * Укладывается ли предложение в предел. Срок бэк шлёт числом или строкой.
 *
 * Предложения без срока (0 / пусто / мусор) не прячем: 0 — это «в наличии»,
 * то есть самый быстрый вариант, а неизвестный срок — не повод считать поставку
 * долгой и молча убирать строку из выдачи.
 */
export function isWithinTermLimit(offer: TermLimitCandidate, limit: number | null): boolean {
  if (limit === null) return true;
  const days = toOfferNumber(offer.time_int);
  if (days <= 0) return true;
  return days <= limit;
}

/** Отбор предложений по пределу срока. Без ограничения набор возвращается как есть. */
export function filterByTermLimit<T extends TermLimitCandidate>(offers: readonly T[], limit: number | null): T[] {
  if (limit === null) return offers as T[];
  return offers.filter((offer) => isWithinTermLimit(offer, limit));
}
